import Configuration from "./configuration";

class TestService {
  constructor(token) {
    this.config = new Configuration(token, null, "");
  }
}

export default TestService;
